



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIAWARDSGETBYID= createAsyncThunk(
  "AlumniAwardGetById/AlumniAwardGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniAwardGetByIdSlice = createSlice({
  name: "AlumniAwardGetByIdSlice",
  initialState: {
    AlumniAwardGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniAwardGetById: (state) => {
        state.AlumniAwardGetById.loading = false
        state.AlumniAwardGetById.error = false
        state.AlumniAwardGetById.data = []
        state.AlumniAwardGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIAWARDSGETBYID.fulfilled, (state, action) => {
      state.AlumniAwardGetById = {
        ...state.AlumniAwardGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIAWARDSGETBYID.pending, (state, action) => {
      state.AlumniAwardGetById = {
        ...state.AlumniAwardGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIAWARDSGETBYID.rejected, (state, action) => {
      state.AlumniAwardGetById = {
        ...state.AlumniAwardGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniAwardGetByIdAction = {
    ALUMNIAWARDSGETBYID,
};

export { AlumniAwardGetByIdAction };
export default AlumniAwardGetByIdSlice.reducer;
export const {setInitialStateOfAlumniAwardGetById} = AlumniAwardGetByIdSlice.actions
